export const optimizeImageLoadingInAlternative = (text: string) => {
  const newContentAnswer = text.replace('<img ', '<img loading="lazy" ');

  return newContentAnswer;
};
